import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/claude/hadatha/hadatha/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/app/components/BookingCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/app/components/FeaturedReleases.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/app/components/NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/app/components/UpcomingEvents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/components/PublicTopbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/claude/hadatha/hadatha/src/components/ui/AppLogo.tsx");
